/**
 * NotFoundPage.tsx — 404 not found page
 *
 * Purpose:    Catch-all route for unknown paths
 * Inputs:     none
 * Outputs:    404 page with nav back to home
 * Constraints: React Router Link for navigation
 * SOT:        T-P3-E3-W2-S5-T01
 */
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <p className="mb-2 font-mono text-sm font-semibold uppercase tracking-widest text-sky-500">
        404
      </p>
      <h1 className="mb-4 text-4xl font-bold">Page not found</h1>
      <p className="mb-8 max-w-md text-brand-muted">
        The page you are looking for does not exist or has been moved.
      </p>
      <div className="flex flex-col items-center gap-3 sm:flex-row">
        <Link
          to="/"
          className="rounded-lg bg-sky-500 px-6 py-3 font-semibold text-white transition hover:bg-sky-400"
        >
          Back to home
        </Link>
        <Link
          to="/features"
          className="rounded-lg border border-brand-card px-6 py-3 font-semibold text-brand-secondary transition hover:border-gray-500 hover:text-brand-ink"
        >
          View features
        </Link>
      </div>
    </div>
  )
}
